import { MutationTree } from 'vuex';
import { CVState } from '@/store/types/CV.state';

export const mutations: MutationTree<CVState> = {
    setToolkit(state, value){
        state.toolkit = value;
    },
    setJobs(state, value){
        state.jobs = value;
    },
    setStudies(state, value){
        state.studies = value;
    },
    setLanguages(state, value){
        state.languages = value;
    },
    setDisplayingSection(state, value){
        state.displayingSection = value;
    },
    setHonors(state, value){
        state.honors = value;
    },
};
